// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px) and (min-width: 601px)";
var _3 = "(max-width: 1024px)";
var _4 = "screen and (max-width: 600px)";
var _5 = "passengers_isMultiCity-1bhwM";
var _6 = "selector-Mlj0-";
var _7 = "menu-22D-R";
var _8 = "item-3gQzI";
var _9 = "passengers_withCurrency-T1whp";
var _a = "passengers-21KOD";
var _b = "alternative-G_8zq";
var _c = "title-2Wi74";
var _d = "mobileTitle-LnWFO";
export { _1 as "__esModule", _2 as "tablet_only", _3 as "tablet", _4 as "mobile", _5 as "passengers_isMultiCity", _6 as "selector", _7 as "menu", _8 as "item", _9 as "passengers_withCurrency", _a as "passengers", _b as "alternative", _c as "title", _d as "mobileTitle" }
export default { "__esModule": _1, "tablet_only": _2, "tablet": _3, "mobile": _4, "passengers_isMultiCity": _5, "selector": _6, "menu": _7, "item": _8, "passengers_withCurrency": _9, "passengers": _a, "alternative": _b, "title": _c, "mobileTitle": _d }
